

















import { Component, Vue } from 'vue-property-decorator';
import { businessFrontPagesService, axiosService } from '@/services';
import { Business } from '@/models/businesses/business';
import { gmaps } from '@/plugins/gmaps';

@Component({})
export default class BusinessesGeolocationTaskView extends Vue {
    private isLoading: boolean = false;
    private businesses: any[] = [];
    private totalRecords: number = 0;
    private hasError: boolean = false;
    private serverParams: any = {
        sort: [
            {
                field: 'id',
                type: 'desc'
            }
        ],
        page: 1,
        perPage: 10
    };
    private wait: number = 2000;

    private async loadItems(): Promise<void> {
        this.isLoading = true;

        const response: any = await axiosService.instance.get('businesses/organization/query', {
            params: this.getQueryParams(this.serverParams.sort, this.serverParams.page, this.serverParams.perPage)
        });

        this.businesses = [];

        this.totalRecords = response.data.count;
        response.data.items.forEach((item: any) => {
            item.result = 'Queded';
            return this.businesses.push(new Business(item));
        });

        this.isLoading = false;
    }

    private getQueryParams(sortOrder: any, currentPage: number, perPage: number): any {
        return {
            $skip: (currentPage - 1) * perPage,
            $top: perPage
        };
    }

    private async geolocateBusinesses(): Promise<any> {
        await this.loadItems();

        let timer = 0;

        /* tslint:disable */
        for (let index = 0; index < this.businesses.length; index++) {
            timer += this.wait;
            setTimeout(
                async business => {
                    business.result = 'Waiting for contact details...';
                    const businessFrontPage = await businessFrontPagesService.getBusinessFrontPage(business.id);

                    if (businessFrontPage.id && businessFrontPage.contactDetails && businessFrontPage.contactDetails.address) {
                        if (!businessFrontPage.contactDetails.address.latitude || !businessFrontPage.contactDetails.address.longitude) {
                            business.result = `Requesting geolocation data of ${businessFrontPage.contactDetails.address.getInOneLine()}`;
                            await gmaps.setAddressLocation(businessFrontPage.contactDetails.address);

                            business.result = 'Adding geolocation data to the databases';

                            if (await businessFrontPagesService.updateBusinessFrontPageContactDetails(business.id, businessFrontPage.contactDetails)) {
                                business.result = `SUCCESS - Data update: (${businessFrontPage.contactDetails.address.latitude},${businessFrontPage.contactDetails.address.longitude}) of ${businessFrontPage.contactDetails.address.getInOneLine()}`;
                            } else {
                                business.result = 'FAILED!';
                            }
                        } else {
                            business.result = 'Skipping, this commerce already has location data.';
                        }
                    } else {
                        business.result = 'Skipping, this commerce has no contact details.';
                    }
                },
                timer,
                this.businesses[index]
            );
        }
        /* tslint:enable */
    }
}
